import React from "react";
import ReactDOM from "react-dom";
import { MainApp } from "./MainApp";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/css/styles.css";
import "./assets/css/programarSalida.css";
import "./assets/css/gps.css";
import "./assets/css/login.css";
import "./assets/css/cronometro.css";
import "./assets/css/paginacion.css";
import "./assets/css/chartContainer.css";
import 'animate.css';
import './assets/css/apertura.css';

ReactDOM.render(<MainApp />, document.getElementById("root"));
